/*
 * action types
 */

export const CHANGE_FOCUSED_STEP = 'CHANGE_FOCUSED_STEP';
export const CHANGE_FOCUSED_ALTERNATIVE = 'CHANGE_FOCUSED_ALTERNATIVE';
export const CHANGE_FOCUSED_POI = 'CHANGE_FOCUSED_POI';
export const CLEAR_FOCUS = 'CLEAR_FOCUS';
